import React, { Component } from 'react';
// import { Trans } from 'react-i18next';
import "../dashboard/Dashboard.css"

class Footer extends Component {
  render () {
    return (
      <footer className="footer bg-white" id='dashFooter'>
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100 footer_text">
            <span className="">Copyright © <a href="https://krludo.in/" target="_blank" rel="noopener noreferrer">krludo.in </a>2025</span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;